import React, { Component } from "react";
import { Row, Col, Modal, Form, Input, message, Spin, Select } from 'antd';

import { AvatarLoader } from "../../Widgets/Uploaders";
import axios from "axios"
import { getResponseError } from "../../Utils";
const { Option } = Select;



/**
 * @class ModalUsuarios
 * @description Modal para el CRUD de Usuarios
 */
class ModalUsuarios extends Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
        }
    }

    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
        if (this.props.usuario_id)
            this.get()

    }

    formRef = React.createRef();

    /**
    * @method addUser
    * @description Añade un nuevo registro de usuario
    */
    get = () => {
        this.setState({ loading: true })
        axios.get('/customer/usuarios/' + this.props.usuario_id)
            .then(({ data }) => {
                console.log("data", data);
                this.formRef.current.setFieldsValue({
                    ...data,
                    telefono: data.cliente_id?.telefono,
                    avatar: data.avatar ? {
                        uid: data.avatar.file,
                        name: data.avatar.name,
                        status: 'done',
                        fromDB: true,
                        url: axios.defaults.baseURL + "/customer/usuarios/" + data._id + "?avatar=" + data.avatar.file + "&Authorization=" + sessionStorage.getItem("token")
                    } : null
                })
                this.setState({ cliente: data.cliente_id })
            }).catch(error => {
                message.error('An error occurred while loading user information')
            }).finally(() => this.setState({ loading: false }))
    }


    /**
    * @method updateUser
    * @description Añade un nuevo registro de usuario
    */
    update = (values) => {

        console.log('update', values)
        this.setState({ loading: true })
        axios.put('/customer/usuarios', values, {
            headers: {
                "Content-Type": 'multipart/form-data'
            }
        })
            .then(response => {
                message.success('User updated successfully')
                this.props.onClose()
            }).catch(error => {
                console.log("error", error);
                message.error(getResponseError(error.response, 'An error occurred while updating the user'))
            }).finally(() => this.setState({ loading: false }))
    }

    /**
   * @method onFinish
   * @description Se ejecuta al hacer submit al formulario
   */
    onFinish = (values) => {

        const formData = new FormData()

        formData.appendMultiple({
            ...values,
            id: this.props.usuario_id,
        })

        if (this.props.usuario_id) {
            this.update(formData)
        }
    }

    render() {
        return (
            <Spin spinning={this.state.loading}>
                <Form
                    id="form-usuario"
                    layout={"vertical"}
                    onFinish={this.onFinish}
                    ref={this.formRef}
                >
                    <Row justify="center" className="center">
                        <Col span={20}>
                            <Row justify={"center"}>
                                <Form.Item
                                    name="avatar"
                                >
                                    <AvatarLoader
                                        imageCrop={true}
                                        onRemove={() => {
                                            axios.put('/usuarios/', {
                                                id: this.props.usuario_id,
                                                delete_avatar: true
                                            })
                                        }}

                                    />
                                </Form.Item>
                            </Row>
                            <Form.Item
                                name="nombre"
                                label="Nombre"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please, enter the name',
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                name="apellidos"
                                label="Last Name"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please, enter the last name',
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                name="email"
                                label="E-mail"
                                rules={[
                                    {
                                        type: 'email',
                                        message: 'Email is not valid',
                                    },
                                    {
                                        required: true,
                                        message: 'Please, enter the email',
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                name="telefono"
                                label="Número Telefónico"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please, enter the phone',
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>

                        </Col>
                    </Row>
                </Form>
            </Spin>
        )
    }


}



export default function Modals(props) {

    const { visible = false, onClose = () => { }, usuario_id } = props

    return <Modal
        open={visible}
        onCancel={onClose}
        title={"Edit User Data"}
        closable={true}
        destroyOnClose={true}
        okText="Guardar"
        cancelText="Cancelar"
        zIndex={1000}
        okButtonProps={{ form: 'form-usuario', key: 'submit', htmlType: 'submit' }}
    >
        <ModalUsuarios  {...props} />
    </Modal>

}